import { useCallback, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router';

import { Maybe, MaybeNull } from 'types';
import { addQuery, parseQuery } from 'helpers/query';

export const useQueryState = <T = string>(name: string): [Maybe<T>, (value?: MaybeNull<T>) => void] => {
  const navigate = useNavigate();
  const location = useLocation();
  const value = useMemo(() => parseQuery(location.search)[name] as unknown, [location.search, name]);

  const setValue = useCallback((value?: MaybeNull<T>) => {
    navigate({
      search: addQuery(location.search, {
        [name]: value,
      }),
    });
  }, [navigate, location.search, name]);

  return [
    Array.isArray(value) ? value[0] : value,
    setValue,
  ];
};
